import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicQuotesService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public show(id: string): Observable<any> {
    return this.publicHttp.get(`/api/public/quotes/${id}`).pipe(tap((_) => console.log("PublicQuotesService.show")));
  }
  public getQuote(id: string): Observable<any> {
    return this.publicHttp
      .get(`/api/public/quotes/${id}/basic_info`)
      .pipe(tap((_) => console.log("PublicQuotesService.getQuote")));
  }

  // TODO: Ensure this endpoint is public.
  public getStep(quote_id: number | string, step: string): Observable<string> {
    const options = { params: { step } };
    return this.publicHttp
      .get(`/api/quotes/${quote_id}/visitas/last_step`, options)
      .pipe(tap((_) => console.log("PublicQuotesService.getStep: Ok.")));
  }

  public updateQuoteByExternalId(external_quote_id: string, quote: any): Observable<any> {
    return this.publicHttp
      .put(`/api/public/cetelem/quote/${external_quote_id}/update_quote_data`, quote)
      .pipe(tap((_) => console.log("PublicQuotesService.updateQuoteByExternalId")));
  }

  public schedule(quote_id: string | number, time: string, activity_id: string | number, action: string) {
    const params = { activity_id: activity_id as string, time, flux_action: action };
    return this.publicHttp
      .post(`/api/quotes/${quote_id}/flux_schedule`, params)
      .pipe(tap((_) => console.log("PublicQuotesService.schedule: Ok.")));
  }

  public updateFlux(quote_id: string | number, action: string, options: any) {
    const params = { flux_action: action, options: JSON.stringify(options) };
    return this.publicHttp
      .post(`/api/quotes/${quote_id}/flux_action`, params)
      .pipe(tap((_) => console.log("PublicQuotesService.updateFlux: Ok.")));
  }

  public getAvailableTime(activity_id: string | number, quote_id: string) {
    const options = { params: { step: "30", activity_id: activity_id as string, quote_id } };
    return this.publicHttp
      .get("/api/users/available_flux_time", options)
      .pipe(tap((_) => console.log("PublicQuotesService.getAvailableTime: Ok.")));
  }
}
